import { supabase, isSupabaseConfigured } from '@/integrations/supabase';

/**
 * 이메일과 비밀번호로 Supabase 회원가입을 수행합니다.
 * @param {{ email: string, password: string, name?: string }} params
 */
export async function signUpWithEmail({ email, password, name }) {
  if (!isSupabaseConfigured) {
    return { data: null, error: new Error('Supabase 환경 변수가 설정되지 않았습니다.') };
  }

  if (!email || !password) {
    return { data: null, error: new Error('이메일과 비밀번호를 입력해주세요.') };
  }

  try {
    const { data, error } = await supabase.auth.signUp({
      email: email.trim(),
      password,
      options: {
        data: {
          name: name ? name.trim() : '',
        },
      },
    });

    if (error) {
      return { data: null, error };
    }

    return { data, error: null };
  } catch (err) {
    return {
      data: null,
      error: err instanceof Error ? err : new Error('회원가입 중 오류가 발생했습니다.'),
    };
  }
}
